import * as z from "zod";

export const AB_TEST_ROADMAP_CALL_STAGES = ["summary", "thanks"] as const;

/**
 * A merchant asked for a call with a conversion expert from the A/B test
 * roadmap. Notifies the Conversion team; nothing is booked.
 */
export const requestAbTestRoadmapCall = {
  name: "requestAbTestRoadmapCall" as const,
  input: z.object({
    /** The screen they asked from: before or after confirming the roadmap. */
    stage: z.enum(AB_TEST_ROADMAP_CALL_STAGES),
  }),
  output: z.null(),
};
export type RequestAbTestRoadmapCallInput = z.infer<
  typeof requestAbTestRoadmapCall.input
>;
